import { render, staticRenderFns } from "./atDg.vue?vue&type=template&id=5b326a9a&"
import script from "./atDg.vue?vue&type=script&lang=js&"
export * from "./atDg.vue?vue&type=script&lang=js&"
import style0 from "./atDg.vue?vue&type=style&index=0&id=5b326a9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports